import { GenericModelApi } from "./GenericModelApi";
import { ApiClient, ApiError, ApiSchema, FetchResponse, NotFoundError } from "./ApiClient";
import { getTenantId } from "@utils/Auth";
import { ExpenseFormData, ExpenseRelatedAttributes } from "@/formTypes/ExpenseDataType";
import { ExpenseFormDataKeys } from "@/generated/ExpenseFormDataKeys";
import { matchesAmplifyFilter } from "@utils/Api";

export type ExpenseDataType = Partial<ApiSchema["Expense"]["type"] & ExpenseFormData>;

class Api extends GenericModelApi<"Expense", ExpenseDataType> {
    protected userSortKeyDateField = "fecha" as const
    /** Se crea desde el frontend, así que la etiqueta del creador se estampa aquí. */
    protected stampsCreatorUser = true


    async fetchAll(filters: any = {}, token?: string, limit: number = 20): Promise<FetchResponse<ExpenseDataType>> {
        const selectionSet = [
            ...ExpenseFormDataKeys.filter(k => !ExpenseRelatedAttributes.includes(k)),
            "currency.*",
            "expenseCategory.*"
        ]

        return super.fetchAll(filters, token, limit, selectionSet);
    }

    async fetchAllByPeriod(startData: string, endData: string, filters: any = {}, token?: string, limit: number = 500): Promise<FetchResponse<ExpenseDataType>> {
        const selectionSet = [
            ...ExpenseFormDataKeys.filter(k => !ExpenseRelatedAttributes.includes(k)),
            "currency.*",
            "expenseNotes.*",
            "expenseCategory.*"
        ]

        return await super.fetchAllByPeriod("listExpenseByTenant", startData, endData, filters, token, {
            selectionSet,
            limit
        })
    }

    async getExpenseByDocumentKey(
        documentKey: string,
        selectionSet?: any
    ): Promise<ExpenseDataType> {
        const tenantId = await getTenantId();

        const fetchFunction = ApiClient.models[this.modelName].listExpenseByDocumentKeyTenant;
        const { data, errors, nextToken: nt } = await fetchFunction({
            owner: tenantId,
            document_key: { eq: documentKey },
        }, {
            limit: 1,
            selectionSet: selectionSet,
        });

        if (errors) {
            throw new ApiError("Error al obtener la registro de gasto", "API_ERROR", errors);
        }

        const pageItems = (data || [])
        if (pageItems.length > 0) {
            return pageItems[0]
        }

        throw new NotFoundError(`No existe ninguna gasto registrado con el codigo la clave ${documentKey} `, "API_ERROR", errors);
    }
}
const api = new Api("Expense", "nombre", "DESC")
api.setCreateDataFieldName("fecha")
export const ExpenseApi = api